import React, { Component } from 'react';

const IconCollections = {
  'iconAsc':'icon-sort fa fa-sort-asc',
  'iconDesc':'icon-sort fa fa-sort-desc',
}

export default class IconToggler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // icon : this.props.iconStart
      icon : IconCollections.iconAsc
    };
    this.iconToggle   = this.iconToggle.bind(this);
  }

  iconToggle(props) {
    const newIcon = this.state.icon === IconCollections.iconAsc ? IconCollections.iconDesc : IconCollections.iconAsc;
    this.setState( {icon: newIcon} );
  }

  render() {
    return(
      <i onClick={this.iconToggle} className={this.state.icon}></i>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App/views/components/Icon/IconToggler.js